import { msg } from '../messages'
import * as Util from '../util'

export function documentacaoRequired(value: any) {
  if (Util.isEmpty(value) || !/\S/.test(value)) {
    return msg('documentacaoRequired', value)
  }
}
